import { PERMISSIONS } from "@/utils/constants";
import permissionMiddleware from "@/router/middlewares/permissionMiddleware";
import authMiddleware from "@/router/middlewares/authMiddleware";

export default [
  {
    path: "/division-orders",
    name: "division-orders",
    component: () => import("../pages/admin/division/order"),
    // meta: {
    //   middleware: [authMiddleware],
    // },
  },
  {
    path: "/division-products",
    name: "division-products",
    component: () => import("../pages/admin/division/product"),
    meta: {
      middleware: [
        permissionMiddleware(PERMISSIONS.DEPARTMENT),
        authMiddleware,
      ],
    },
  },
  {
    path: "/division-contracts",
    name: "division-contracts",
    props: true,
    component: () => import("../pages/admin/division/contract.vue"),
    meta: {
      middleware: [
        authMiddleware,
        permissionMiddleware(PERMISSIONS.DEPARTMENT),
      ],
    },
  },
  {
    path: "/division-accept",
    name: "division-accept",
    props: true,
    component: () => import("../pages/admin/division/accept.vue"),
    meta: {
      middleware: [
        authMiddleware,
        permissionMiddleware(PERMISSIONS.DEPARTMENT),
      ],
    },
  },
  {
    path: "/division-product-accept/:id",
    name: "division-product-accept",
    props: true,
    component: () => import("../pages/admin/division/accept-product.vue"),
    meta: {
      middleware: [authMiddleware],
    },
  },
  {
    path: "/all-order-products",
    name: "all-order-products",
    component: () => import("../pages/admin/division/all-order-product"),
    meta: {
      middleware: [
        authMiddleware,
        permissionMiddleware(PERMISSIONS.DIVISION_ORDER),
      ],
    },
  },
  {
    path: "/create-order",
    name: "create-order",
    component: () => import("../pages/admin/division/create-order"),
    meta: {
      middleware: [
        authMiddleware,
        permissionMiddleware(PERMISSIONS.DIVISION_ORDER),
      ],
    },
  },
];
